import CSS_CLASS from '../constants/cssClass'
import generateId from '../utils/generateId'
import renderSnippets from '../snippet/renderSnippets'
import initSnippetsFilter from '../snippet/initSnippetsFilter'
import hideSnippetSidebarLeft from './hideSnippetSidebarLeft'
import initSnippetAction from './initSnippetAction'
import addSnippetToTarget from '../snippet/addSnippetToTarget'
import initSidebarLeft from './initSidebarLeft'
import closeSidebar from '../sidebar/closeSidebar'
import deleteSnippet from '../snippet/deleteUserSnippet'
import getUserSnippets from '../snippet/getUserSnippets'

const getLocalStorageSnippets = () =>
{
  return JSON.parse(localStorage.getItem('@mf/templates') ?? '[]').map((item) =>
  {
    let id = item.id;
    let template = $(item.template);
    let content = $(template.html());

    //Add local-snippet-id to content
    content.attr('data-local-snippet-id', id);

    template.html(content);

    return {
      id: item.id,
      snippetId: template.data('keditor-snippet-id'),
      title: item.title,
      template: template.prop('outerHTML'),
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
    }
  })
}

export default function () {
  const self = this
  const { options } = self
  self.sidebarLeft = initSidebarLeft.call(self, generateId(), false, true)

  if (
    typeof options.snippetsUrl === 'string' &&
    options.snippetsUrl.length > 0
  ) {
    self.sidebarLeft
      .find(`.${CSS_CLASS.SIDEBAR_LEFT_BODY}`)
      .append(`<div class="${CSS_CLASS.BOOTSTRAP_TAB_CONTENT}"></div>`)

    $.ajax({
      type: 'get',
      dataType: 'html',
      url: options.snippetsUrl,
      success(resp) {
        if (typeof options.onSnippetsLoaded === 'function') {
          resp = options.onSnippetsLoaded.call(self, resp) || resp
        }
        const getLocalStorageSnippetsData = getLocalStorageSnippets()
        let snippets = resp

        getUserSnippets.call(self, function (success, response)
        {
          //Remove duplicated snippets from local storage
          response = response.filter((item) =>
          {
            return !getLocalStorageSnippetsData.find((localItem) => localItem.snippetId === item.id)
          })
          
          snippets += response.reduce((acc, item) =>
          {
            return acc + item.template ?? ''
          }, '')

          snippets += getLocalStorageSnippetsData.reduce((acc, item) =>
          {
            return acc + item.template ?? ''
          }, '')

          // render snippets
          renderSnippets.call(self, snippets)
          // render filters
          initSnippetsFilter.call(self)
        })
      },
      error(jqXHR) {
        if (typeof options.onSnippetsError === 'function') {
          options.onSnippetsError.call(self, jqXHR)
        }
      },
    })

    // Snippet events
    initSnippetAction.call(self)

    // Close buttons
    self.sidebarLeft
      .find(`.${CSS_CLASS.SIDEBAR_LEFT_CLOSER}`)
      .on('click', function (e) {
        e.preventDefault()

        hideSnippetSidebarLeft.call(self)
      })

    // Add buttons
    self.sidebarLeft.on('click', `.${CSS_CLASS.TOOLBAR_BLOCK}`, function (e)
    {
      e.preventDefault()
      e.stopPropagation()

      const selectedSnippet = $(this).closest(`.${CSS_CLASS.SNIPPET}`)

      deleteSnippet.call(self, e, selectedSnippet)
    })

    self.sidebarLeft.on('click', `.${CSS_CLASS.SNIPPET}`, function (e) {
      e.preventDefault()

      const selectedSnippet = $(this)

      addSnippetToTarget.call(
        self,
        e,
        selectedSnippet,
        self.sidebarLeftTarget,
        self.sidebarLeftTargetAction
      )
      hideSnippetSidebarLeft.call(self)
      closeSidebar.call(self)
    })
  } else {
    self.error('"snippetsUrl" must be not null!')
  }
}
